export default function trimFormFields(fields) {
  // reassigning objects while looping throught it can lead to unexpected results
  // it is simply safer to create a copy and use it
  const formattedFields = fields;

  Object.keys(fields).forEach(key => {
    formattedFields[key] = fields[key].trim();
  });

  return formattedFields;
}
